import type { KpiComparisonPeriod } from "@types";

export type MaintenanceType = "PREVENTIVE" | "CORRECTIVE" | "SINGLE" | "SUBSCRIPTION";

export const MAINTENANCE_TYPES: MaintenanceType[] = ["PREVENTIVE", "CORRECTIVE", "SINGLE", "SUBSCRIPTION"];

export type MaintenanceStatus = "DONE" | "SCHEDULED" | "CANCELLED";

export type MaintenanceAlertSeverity = "CRITICAL" | "WARNING" | "INFO";

export type MaintenanceAlertType =
  "CORRECTIVE_CONCENTRATION" | "COST_PER_KM_INCREASE" | "COST_PER_VEHICLE_DECREASE" | "BUDGET_EXCEEDED";

export const MAINTENANCE_ALERT_TYPES: MaintenanceAlertType[] = [
  "CORRECTIVE_CONCENTRATION",
  "COST_PER_KM_INCREASE",
  "COST_PER_VEHICLE_DECREASE",
  "BUDGET_EXCEEDED",
];

export interface MaintenanceSummaryMetric {
  value: number;
  previousValue: number;
  variationPercent: number | null;
  currentPeriod?: KpiComparisonPeriod | null;
  previousPeriod?: KpiComparisonPeriod | null;
}

export interface MaintenanceSummary {
  totalSpent: MaintenanceSummaryMetric;
  averageCostPerKm: MaintenanceSummaryMetric & { kmDriven: number };
  averageCostPerVehicle: MaintenanceSummaryMetric;
}

export interface MaintenanceTypeTotal {
  type: MaintenanceType;
  amount: number;
}

export interface MaintenanceSubcategoryTotal {
  subcategory: string;
  amount: number;
}

export interface MaintenanceVehicleCost {
  vehicle: string;
  amount: number;
  costPerKm: number;
}

export interface MaintenanceTransaction {
  id: string;
  dateTime: string;
  vehicle: string;
  type: MaintenanceType;
  subcategory: string;
  paymentMethod: string;
  amount: number;
  status: MaintenanceStatus;
}

export interface MaintenanceAlert {
  id: string;
  type: MaintenanceAlertType;
  severity: MaintenanceAlertSeverity;
  title: string;
  description: string;
  occurredAt: string;
}

export interface MaintenanceAlertTotals {
  total: number;
  alerts: Partial<Record<MaintenanceAlertType, number>>;
}

export interface MaintenanceAlertMetric {
  label: string;
  value: number;
  highlighted: boolean;
}

export interface MaintenanceAlertDetail extends MaintenanceAlert {
  metrics: MaintenanceAlertMetric[];
}
